import React, {Fragment, useState} from "react";
import Modal_Login_reg from "../components/Modal_Login_reg/Modal_Login_reg";
import Modal_Select_agent from "../components/Modal_Select_agent/Modal_Select_agent";
import Header from "../components/Header/Header";
import Footer from "../components/Footer";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
///import Nav from "../components/Nav";

    const Master_Front = (props) => {

    return (
      <Fragment>

          <Modal_Login_reg/>

          <Modal_Select_agent/>

          <Header  wallet_balance={props.wallet_balance} first_name_profile={props.first_name_profile} last_name_profile={props.last_name_profile}    />

    <main className="box_front_master w-100 box_container_bk" >
        <ToastContainer />


        {props.children}




        { String(props.bottom_navbar_show)=="hide" ?  (

            <Fragment>

            </Fragment>

        ) : (
            <Fragment>
                {/*<Nav />*/}
            </Fragment>

        ) }





    </main>

          {
              String(props.footer_show)=="hide" ?  (

                  <Fragment></Fragment>

              ) : (
                  <Fragment>
                      <Footer />
                  </Fragment>

              )

          }

      </Fragment>
    );
  }

  export default Master_Front;